import React, { useEffect, useState } from 'react'
import axios from 'axios'
import SceneList from '../../Components/Scene/SceneList'
import { Pagination } from 'react-bootstrap'

const index = () => {
  const [filters, setFilters] = useState({
    publicYn: 'all',
    approveYn: 'all',
    status: 'all',
    q: '',
  })
  const [pageNumber, setPageNumber] = useState(1)
  const [pageMap, setPageMap] = useState({})
  const [sceneList, setSceneList] = useState([])

  useEffect(() => {
    getScene()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, filters.publicYn, filters.approveYn, filters.status])

  const changeFilters = next => {
    setFilters(prev => ({ ...prev, ...next }))
    setPageNumber(1)
  }

  const getScene = async n => {
    const { publicYn, approveYn, status, q } = filters

    await axios
      .get(
        `/new/webAdmin/v2/scene?approveYn=${approveYn}&publicYn=${publicYn}&status=${status}&q=${encodeURIComponent(
          q
        )}&pageNumber=${n ? n : pageNumber}&limit=20`,
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )
      .then(({ data }) => {
        setSceneList(data.body.list || [])
        setPageMap(data.body.pageMap || {})
      })
      .catch(err => {
        console.error('[scene/list] error:', err)
      })
  }

  const search = () => {
    setPageNumber(1)
    getScene(1)
  }

  const renderPaging = (pageNumber, pageMap) => {
    let list = []
    let j = 0
    let i = 0

    let test = pageNumber !== 1 ? pageNumber - 1 : 1
    let last =
      pageNumber !== pageMap.pageCount ? pageNumber * 1 + 1 : pageMap.pageCount

    list.push(
      <Pagination.Item
        key="first"
        onClick={() => {
          setPageNumber(test)
        }}
      >
        &laquo;
      </Pagination.Item>
    )

    for (i = pageMap.startPage * 1; i <= pageMap.endPage; i++) {
      let num = pageMap.startPage * 1 + j

      if (num === pageMap.pageNumber * 1) {
        list.push(
          <Pagination.Item key={i} className="active">
            {num}
          </Pagination.Item>
        )
      } else {
        list.push(
          <Pagination.Item
            key={i}
            onClick={() => {
              setPageNumber(num)
            }}
          >
            {num}
          </Pagination.Item>
        )
      }
      j++
    }

    list.push(
      <Pagination.Item
        key="last"
        onClick={() => {
          setPageNumber(last)
        }}
      >
        &raquo;
      </Pagination.Item>
    )
    return <Pagination>{list}</Pagination>
  }

  return (
    <>
      <SceneList
        sceneList={sceneList}
        filters={filters}
        setFilters={changeFilters}
        search={search}
        totalCount={pageMap.totalCount}
      />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        {pageMap && pageMap.pageCount ? renderPaging(pageNumber, pageMap) : null}
      </div>
    </>
  )
}

export default index
